export default {
  "components": {
    "dates": {
      "sun": {
        "default": "Sunday",
        "value": "Dimanche"
      },
      "mon": {
        "default": "Monday",
        "value": "Lundi"
      },
      "tue": {
        "default": "Tuesday",
        "value": "Mardi"
      },
      "wed": {
        "default": "Wednesday",
        "value": "Mercredi"
      },
      "thu": {
        "default": "Thursday",
        "value": "Jeudi"
      },
      "fri": {
        "default": "Friday",
        "value": "Vendredi"
      },
      "sat": {
        "default": "Saturday",
        "value": "Samedi"
      },
      "suns": {
        "default": "Sun",
        "value": "Di"
      },
      "mons": {
        "default": "Mon",
        "value": "Lu"
      },
      "tues": {
        "default": "Tue",
        "value": "Ma"
      },
      "weds": {
        "default": "Wed",
        "value": "Me"
      },
      "thus": {
        "default": "Thu",
        "value": "Je"
      },
      "fris": {
        "default": "Fri",
        "value": "Ve"
      },
      "sats": {
        "default": "Sat",
        "value": "Sa"
      },
      "jan": {
        "default": "January",
        "value": "Janvier"
      },
      "feb": {
        "default": "February",
        "value": "Février"
      },
      "mar": {
        "default": "March",
        "value": "Mars"
      },
      "apr": {
        "default": "April",
        "value": "Avril"
      },
      "may": {
        "default": "May",
        "value": "Mai"
      },
      "jun": {
        "default": "June",
        "value": "Juin"
      },
      "jul": {
        "default": "July",
        "value": "Juillet"
      },
      "aug": {
        "default": "August",
        "value": "Août"
      },
      "sep": {
        "default": "September",
        "value": "Septembre"
      },
      "oct": {
        "default": "October",
        "value": "Octobre"
      },
      "nov": {
        "default": "November",
        "value": "Novembre"
      },
      "dec": {
        "default": "December",
        "value": "Décembre"
      },
      "jans": {
        "default": "Jan",
        "value": "Jan"
      },
      "febs": {
        "default": "Feb",
        "value": "Fév"
      },
      "mars": {
        "default": "Mar",
        "value": "Mar"
      },
      "aprs": {
        "default": "Apr",
        "value": "Avr"
      },
      "mays": {
        "default": "May",
        "value": "Mai"
      },
      "juns": {
        "default": "Jun",
        "value": "Jun"
      },
      "juls": {
        "default": "Jul",
        "value": "Jul"
      },
      "augs": {
        "default": "Aug",
        "value": "Aoû"
      },
      "seps": {
        "default": "Sep",
        "value": "Sep"
      },
      "octs": {
        "default": "Oct",
        "value": "Oct"
      },
      "novs": {
        "default": "Nov",
        "value": "Nov"
      },
      "decs": {
        "default": "Dec",
        "value": "Déc"
      }
    },
    "commonPersonalData": {
      "errInvalidFields": {
        "default": "Invalid form fields.",
        "value": "Champs de saisie non valides"
      },
      "personalDataSaved": {
        "default": "Your data has been saved.",
        "value": "Vos données sont sauvegardées."
      }
    },
    "validations": {
      "cannotBeEmpty": {
        "default": "This field cannot be empty.",
        "value": "Ce champ est obligatoire."
      },
      "notAnEmail": {
        "default": "Provided value is not a valid email address.",
        "value": "Ceci n'est pas une adresse électronique valide."
      },
      "passwordLength": {
        "default": "The password must be minimum ${charNo} characters with at least one lowercase character and one special character.",
        "value": "Le mot de passe doit comporter au moins ${charNo} caractères, dont au moins une minuscule et un caractère spécial."
      }
    },
    "bwReceipt": {
      "barOffer": {
        "default": "Offer",
        "value": "Offre"
      },
      "barExtras": {
        "default": "Extras",
        "value": "Suppléments "
      },
      "barMietbetrag": {
        "default": "Rental fee",
        "value": "Prix"
      },
      "recOffer": {
        "default": "Offer",
        "value": "Offre"
      },
      "recServices": {
        "default": "Services",
        "value": "Services"
      },
      "recDiscount": {
        "default": "Discount",
        "value": "Remise"
      },
      "recAccessories": {
        "default": "Accessories",
        "value": "Suppléments"
      },
      "recDeposit": {
        "default": "Kaution",
        "value": "Dépôt de garantie"
      },
      "bookedFrom": {
        "default": "Booking from",
        "value": "Réservation de"
      },
      "bookedTo": {
        "default": "to",
        "value": "à"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Remise"
      },    
      "totalSurcharge": {
        "default": "Total Discount",
        "value": "Surcharge totale"
      },          
      "vatIncluded": {
        "default": "All prices are including VAT.",
        "value": "Tous les prix incluent la TVA."
      }            
    },
    "bwStepBar": {
      "bookingDates": {
        "default": "Bookingdates",
        "value": "Détails de la réservation"
      },
      "services": {
        "default": "Services",
        "value": "Services"
      },
      "accessories": {
        "default": "Accessories",
        "value": "Suppléments"
      },
      "personalData": {
        "default": "Contact data",
        "value": "Données à caractère personnel"
      },
      "review": {
        "default": "Review",
        "value": "Consultez le site"
      },
      "payment": {
        "default": "Payment",
        "value": "Paiement"
      }
    },
    "siteHeader": {
      "passwordRecovery": {
        "default": "Passwort vergessen?",
        "value": "Mot de passe oublié?"
      },      
      "login": {
        "default": "Login",
        "value": "Login"
      },
      "userName": {
        "default": "Username",
        "value": "Nom d'utilisateur"
      },
      "password": {
        "default": "Password",
        "value": "Mot de passe"
      },
      "performLogin": {
        "default": "Login",
        "value": "Login"
      },
      "newRegistration": {
        "default": "Sign up",
        "value": "S'enregistrer"
      },
      "userProfile": {
        "default": "My profile",
        "value": "Mon profil"
      },
      "userBookings": {
        "default": "My bookings",
        "value": "Mes réservations"
      },
      "performLogout": {
        "default": "Log out",
        "value": "Déconnecter"
      }
    },
    "siteFooter": {
      "claimText1": {
        "default": "Das umfassende",
        "value": "Le système global"        
      },
      "claimText2": {
        "default": "Reservationssystem",
        "value": "de réservation"   
      },  
      "claimText3": {
        "default": "für Sie",
        "value": "pour vous"
      }          
    }    
  },
  "pages": {
    "bw03Accessories": {
      "back": {
        "default": "Back",
        "value": "Retour"
      },
      "accessories": {
        "default": "Accessories",
        "value": "Extras"
      },
      "next": {
        "default": "Next",
        "value": "Continuer"
      }
    },
    "bw07BookingFinished": {
      "confirmation": {
        "default": "Confirmation",
        "value": "Confirmation"
      },
      "bookingFor": {
        "default": "The booking for",
        "value": "La réservation pour"
      },
      "fromDate": {
        "default": "from",
        "value": "de"
      },
      "toDate": {
        "default": "to",
        "value": "à"
      },
      "forPrice": {
        "default": "for",
        "value": "pour"
      },
      "wasFinished": {
        "default": "was successfully completed.",
        "value": "a été menée à bien."
      },
      "bookingDetailsSent": {
        "default": "The booking details and invoice have been sent to your e-mail address.",
        "value": "Les détails de la réservation ont été envoyés à votre adresse électronique."
      },
      "performRegister": {
        "default": "Sign up",
        "value": "S'enregistrer"
      },
      "performPrint": {
        "default": "Print confirmation",
        "value": "Imprimer la confirmation"
      },
      "goHome": {
        "default": "Go to homepage ",
        "value": "Vers la page d'accueil"
      }
    },
    "bw01OfferDetails": {
      "next": {
        "default": "Next",
        "value": "Continuer"
      },
      "bookingDates": {
        "default": "Booking data",
        "value": "Détails de la réservation"
      },
      "instructionsTitle1": {
        "default": "Instructions",
        "value": "Instructions"
      },
      "instructionsText1": {
        "default": "Passen Sie bei Bedarf die Start- und Endzeiten an. Beachten Sie, dass das System Ihre Angaben automatisch korrigieren kann um die Buchungsregeln des Anbieters zu berücksichtigen.",
        "value": "Ajustez les heures de début et de fin si nécessaire. Notez que le système peut automatiquement corriger vos entrées pour tenir compte des règles de réservation du fournisseur."
      },      
      "startDate": {
        "default": "Start time",
        "value": "Heure de début"
      },
      "endDate": {
        "default": "End time",
        "value": "Heure de fin"
      },
      "applyNewValues": {
        "default": "Show",
        "value": "Annonces"
      },
      "weekView": {
        "default": "Week view",
        "value": "vue hebdomadaire"
      },
      "monthView": {
        "default": "Month view",
        "value": "Vers la vue du mois"
      },
      "yourChoice": {
        "default": "Your selection",
        "value": "votre choix"
      },
      "instructionsTitle2": {
        "default": "Instructions",
        "value": "Instructions"
      },
      "yourBooking": {
        "default": "Your reservation",
        "value": "votre réservation"
      },
      "notAvailable": {
        "default": "Not available",
        "value": "Non disponible"
      },
      "pickupDrop": {
        "default": "Pickup and return times",
        "value": "Heures de début et de fin"
      },
      "back": {
        "default": "Back",
        "value": "Retour"
      }
    },
    "bw06Payment": {
      "payment": {
        "default": "Payment",
        "value": "Paiement"
      },
      "bankAccount": {
        "default": "Banking details",
        "value": "Coordonnées bancaires"
      },
      "bankPaymentConditions": {
        "default": "Payment conditions",
        "value": "Conditions de paiement"
      },
      "back": {
        "default": "Back",
        "value": "Retour"
      },
      "firmlyBookFor": {
        "default": "Book bindingly for",
        "value": "Poste obligatoire pour"
      }
    },
    "bw04PersonalData": {
      "street": {
        "default": "Street, Nr. *",
        "value": "Rue, Numéro *"
      },
      "addressAddition": {
        "default": "Address suffix",
        "value": "Adresse ligne 2"
      },
      "postNumber": {
        "default": "ZIP *",
        "value": "NPA *"
      },
      "place": {
        "default": "Place *",
        "value": "Ville *"
      },
      "country": {
        "default": "Country *",
        "value": "Pays *"
      },
      "back": {
        "default": "Back",
        "value": "Retour"
      },
      "personalData": {
        "default": "Contact details",
        "value": "Données à caractère personnel"
      },
      "pleaseLogin": {
        "default": "Please log in",
        "value": "Veuillez vous connecter"
      },
      "userName": {
        "default": "User name",
        "value": "Nom d'utilisateur"
      },
      "password": {
        "default": "Password",
        "value": "Mot de passe"
      },
      "loginAsGuest": {
        "default": "Book as guest",
        "value": "Réserver en tant qu'invité"
      },
      "login": {
        "default": "Log in",
        "value": "S'inscrire "
      },
      "customerInformation": {
        "default": "Customer information",
        "value": "Informations sur les clients"
      },
      "salutation": {
        "default": "Salutation *",
        "value": "Civilité *"
      },
      "firstName": {
        "default": "First name *",
        "value": "Prénom *"
      },
      "lastName": {
        "default": "Family Name *",
        "value": "Nom de famille *"
      },
      "organization": {
        "default": "Organization",
        "value": "Organisation"
      },          
      "email": {
        "default": "Email *",
        "value": "Courrier électronique *"
      },
      "phone": {
        "default": "Phone",
        "value": "Téléphone :"
      },
      "mobilePhone": {
        "default": "Cellphone *",
        "value": "Mobile *"
      },        
      "address": {
        "default": "Address",
        "value": "Adresse"
      },
      "useDifferentBillingAddress": {
        "default": "Use different address for billing.",
        "value": "Adresse de facturation différente"
      },
      "cancelGuestLogin": {
        "default": "Cancel guest booking",
        "value": "Annuler la réservation d'un invité"
      },
      "next": {
        "default": "Next",
        "value": "Continuer"
      }
    },
    "bw05Review": {
      "discount": {
        "default": "Disount",
        "value": "Remise"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Remise"
      }, 
      "totalSurcharge": {
        "default": "Total Discount",
        "value": "Surcharge totale"
      },                
      "offer": {
        "default": "Angebot",
        "value": "Offre"
      },  
      "services": {
        "default": "Dienstleistungen",
        "value": "Services"
      },     
      "accessories": {
        "default": "Extras",
        "value": "Extras"
      },           
      "deposit": {
        "default": "Kaution",
        "value": "Dépôt de garantie"
      },      
      "review": {
        "default": "Review",
        "value": "Consultez"
      },
      "mietbetrag": {
        "default": "Rental fee",
        "value": "Prix"
      },
      "bookedFrom": {
        "default": "Booking from",
        "value": "réservation de"
      },
      "bookedTo": {
        "default": "to",
        "value": "à"
      },
      "bookingDetails": {
        "default": "Bookingdetails",
        "value": "Détails de la réservation"
      },
      "vatIncluded": {
        "default": "Incl. VAT.",
        "value": "TVA incluse"
      },
      "voucher": {
        "default": "Voucher",
        "value": "Bon d'achat"
      }, 
      "addVoucher": {
        "default": "Add Voucher",
        "value": "Ajouter un bon d'achat"
      },        
      "bookAs": {
        "default": "Book as",
        "value": "Réservez comme"
      },
      "bookFirmly": {
        "default": "Book bindingly",
        "value": "Reliure de livres"
      },
      "temporaryReservationUntil": {
        "default": "Temporäre Reservation, gültig bis",
        "value": "Réservation temporaire, valable jusqu'au"
      },
      "acceptAGB": {
        "default": "I accept the",
        "value": "J'accepte la ${lessorName}"
      },
      "agb": {
        "default": "General terms and conditions",
        "value": "Cond. gén."
      },
      "back": {
        "default": "Back",
        "value": "Retour"
      },
      "next": {
        "default": "Next",
        "value": "Continuer"
      },
      "nextTitle": {
        "default": "Alle Pflichtfelder müssen ausgefüllt und die AGBs akzeptieren werden.",
        "value": "Tous les champs obligatoires doivent être remplis et les Cond. gén. doivent être acceptés."
      }      
    },
    "bw02Services": {
      "next": {
        "default": "Next",
        "value": "Continuer"
      },
      "services": {
        "default": "Services",
        "value": "Services"
      },
      "back": {
        "default": "Back",
        "value": "Retour"
      }
    },
    "objectDetail": {
      "back": {
        "default": "Back",
        "value": "Retour"
      },
      "fromPrice": {
        "default": "Starting at",
        "value": "A partir de"
      },
      "bookObject": {
        "default": "Book objects",
        "value": "Réserver"
      },
      "properties": {
        "default": "Features",
        "value": "Propriétés"
      },
      "notBookableOnline": {
        "default": "Kann nicht online gebucht werden. Bitte kontaktieren Sie den Anbieter.",
        "value": "Ne peut pas être réservé en ligne. Veuillez contacter le fournisseur."
      },      
      "showMoreProperties": {
        "default": "Show more features",
        "value": "Afficher plus de propriétés"
      },
      "showLessProperties": {
        "default": "Close",
        "value": "Fermer"
      },
      "attachments": {
        "default": "Attachments",
        "value": "Annexes"
      },
      "unnamedAttachment": {
        "default": "Attachment",
        "value": "Annexe"
      },
      "showMoreAttachments": {
        "default": "Show more attachements",
        "value": "Afficher plus d'annexes"
      },
      "showLessAttachments": {
        "default": "Close",
        "value": "Fermer"
      },
      "availableDates": {
        "default": "Available dates",
        "value": "Données disponibles"
      },
      "availableDatesDescription": {
        "default": "If necessary, change booking dates in the next step.",
        "value": "Les données de réservation souhaitées peuvent être ajustées lors de l'étape suivante."
      },
      "weekView": {
        "default": "Week view",
        "value": "Vue hebdomadaire"
      },
      "monthView": {
        "default": "Month view",
        "value": "Vers la vue du mois"
      },
      "yourChoice": {
        "default": "Your selection",
        "value": "votre choix"
      },
      "notAvailable": {
        "default": "Not available",
        "value": "Non disponible"
      },
      "pickupDrop": {
        "default": "Pickup and return times",
        "value": "Heures de début et de fin"
      },
      "offers": {
        "default": "Offers",
        "value": "Offres"
      },
      "consumables": {
        "default": "Consumables",
        "value": "Utilisez"
      },
      "services": {
        "default": "Services",
        "value": "Services"
      },
      "accessories": {
        "default": "Accessories",
        "value": "Extras"
      },
      "cancellationFees": {
        "default": "Cancellation fees",
        "value": "Frais d'annulation"
      },
      "seasonDatetimes": {
        "default": "Saisonzeiten",
        "value": "Temps de la saison"
      },
      "pickups": {
        "default": "Startzeit",
        "value": "Heure de début"
      },
      "dropoffs": {
        "default": "Endzeit",
        "value": "Heure de fin"
      },
      "prolongation": {
        "default": "Verlängerung",
        "value": "Extension"
      },        
      "description": {
        "default": "Description",
        "value": "Description"
      }, 
      "noOfferItems": {
        "default": "There are no offers.",
        "value": "Pas d'offres"
      },
      "showMoreOffers": {
        "default": "Show more offers",
        "value": "Afficher plus d'offres"
      },
      "showLessOffers": {
        "default": "Close",
        "value": "Fermer"
      },
      "noConsumables": {
        "default": "There are no consumables.",
        "value": "Pas de données utilisateur"
      },
      "consumablesTabDescription": {
        "default": "Included consumables",
        "value": "Usage inclus"
      },
      "showMoreConsumables": {
        "default": "Show more consumables",
        "value": "Afficher plus de coûts d'utilisation"
      },
      "showLessConsumables": {
        "default": "Close",
        "value": "Fermer"
      },
      "consumableMinimum": {
        "default": "At least",
        "value": "au moins"
      },       
      "consumableFooterDescription": {
        "default": "pro zusätzliche(n)",
        "value": "Par tranche additionnelle "
      }, 
      "noServices": {
        "default": "There are no services.",
        "value": "Pas de services"
      },
      "discount": {
        "default": "Discount",
        "value": "Remise"
      },
      "showMoreServices": {
        "default": "Show more services",
        "value": "Voir plus de services"
      },
      "showLessServices": {
        "default": "Close",
        "value": "Fermer"
      },
      "noAccessories": {
        "default": "There are no accessories.",
        "value": "Pas d'extras"
      },
      "showMoreAccessories": {
        "default": "Show more accessories",
        "value": "Voir plus d'extras"
      },
      "showLessAccessories": {
        "default": "Close",
        "value": "Fermer"
      },
      "noCancellationFees": {
        "default": "No cancellation fees",
        "value": "Pas de frais d'annulation"
      },
      "daysToPickup": {
        "default": "Days until pickup",
        "value": "Jours pour commencer, ou plus tôt"
      },
      "hoursToPickup": {
        "default": "Hours until pickup",
        "value": "Heures pour commencer, ou plus tôt"
      },      
      "percent": {
        "default": "Percent",
        "value": "Pourcentage"
      },
      "fix": {
        "default": "Fix",
        "value": "Fixe"
      },
      "showMoreCancellationFees": {
        "default": "Show more fees",
        "value": "Afficher plus de frais"
      },
      "showLessCancellationFees": {
        "default": "Close",
        "value": "Fermer"
      }
    },
    "home": {
      "location": {
        "default": "Location",
        "value": "Lieu"
      },
      "allLocationsSelected": {
        "default": "All locations",
        "value": "Tous"
      },
      "selectAllLocations": {
        "default": "All locations",
        "value": "Tous"
      },
      "noItemsLoadedYet": {
        "default": "No items loaded yet.",
        "value": "Aucune entrée n'a encore été chargée"
      },
      "objectType": {
        "default": "Category",
        "value": "Catégorie"
      },
      "allCategoriesSelected": {
        "default": "All categories",
        "value": "Tous"
      },
      "selectAllCategories": {
        "default": "All categories.",
        "value": "Tous"
      },
      "startDate": {
        "default": "Start date *",
        "value": "Date de début *"
      },
      "noStartDateSelected": {
        "default": "No start date selected.",
        "value": "Aucune date de début n'a été sélectionnée."
      },
      "duration": {
        "default": "Duration *",
        "value": "Durée *"
      },
      "to": {
        "default": "to",
        "value": "à"
      },
      "count": {
        "default": "Number",
        "value": "Quantité"
      },
      "enterUnitsCount": {
        "default": "Enter units count",
        "value": "Entrez la quantité"
      },
      "timeUnit": {
        "default": "Time unit",
        "value": "Unité de temps"
      },
      "enterUnitsType": {
        "default": "Enter units type",
        "value": "Sélectionnez l'unité de temps"
      },
      "search": {
        "default": "Search",
        "value": "Recherchez"
      },
      "priceFrom": {
        "default": "From",
        "value": "A partir de"
      }
    },
    "userBookingDetail": {
      "cancelBookingMessage": {
        "default": "You are going to cancel this booking. Are you sure?",
        "value": "Voulez-vous vraiment annuler la réservation?" 
      },      
      "enthalteneMwst": {
        "default": "Enthaltene MwSt (${vatPercentage}%)",
        "value": "TVA incluse (${vatPercentage}%)"
      },
      "stornoGebuhren": {
        "default": "Storno-Gebühren",
        "value": "Frais d'annulation"
      },
      "daysToPickup": {
        "default": "Tage bis zur Startzeit, oder früher",
        "value": "Jours pour commencer l'heure, ou plus tôt"
      },
      "hoursToPickup": {
        "default": "Stunden bis zur Startzeit, oder früher",
        "value": "Heures pour commencer l'heure, ou plus tôt"
      },      
      "gesamtbetragFallig": {
        "default": "Gesamtbetrag, fällig",
        "value": "Montant total, dû"
      },
      "anzahlungFallig": {
        "default": "Anzahlung, fällig",
        "value": "Acompte, dû"
      },
      "back": {
        "default": "Returned",
        "value": "Retour"
      },
      "performPrint": {
        "default": "Print",
        "value": "Imprimer"
      },
      "performCancel": {
        "default": "Cancel",
        "value": "Annuler"
      },
      "mietbetrag": {
        "default": "Rental fee",
        "value": "Prix"
      },
      "vatIncluded": {
        "default": "Incl. VAT.",
        "value": "y compris la TVA"
      },      
      "bookedFrom": {
        "default": "Booking from",
        "value": "Réservation de"
      },
      "bookedTo": {
        "default": "to",
        "value": "à"
      },
      "bookingNumber": {
        "default": "Booking-No.",
        "value": "N° de réservation"
      },
      "bookingState": {
        "default": "Status",
        "value": "Statut"
      },
      "bookingSaldo": {
        "default": "Balance",
        "value": "Balance des paiements"
      },
      "objectAndAccessories": {
        "default": "Rental object and accessories",
        "value": "L'objet et les extras"
      },
      "description": {
        "default": "Description",
        "value": "Description"
      },
      "count": {
        "default": "Qty.",
        "value": "Quantité"
      },
      "offer": {
        "default": "Offer",
        "value": "Offre"
      },
      "season": {
        "default": "Season",
        "value": "Saison"
      },
      "deposit": {
        "default": "Kaution",
        "value": "Dépôt de garantie"
      },        
      "price": {
        "default": "Price",
        "value": "Prix"
      },
      "subTotal": {
        "default": "Subtotal",
        "value": "Sous-total"
      },
      "conditionalServices": {
        "default": "Conditional fees",
        "value": "Honoraires conditionnels"
      },
      "article": {
        "default": "Article",
        "value": "Article"
      },
      "subtotal": {
        "default": "Subtotal",
        "value": "Sous-total"
      },
      "services": {
        "default": "Services",
        "value": "Services"
      },
      "discount": {
        "default": "Discount",
        "value": "Remise"
      },
      "totalDiscount": {
        "default": "Total Discount",
        "value": "Remise"
      },       
      "consumables": {
        "default": "Consumables",
        "value": "Utilisez"
      },
      "consumableName": {
        "default": "Description",
        "value": "Désignation"
      },
      "unit": {
        "default": "Unit",
        "value": "Unité"
      },
      "minIncl": {
        "default": "Min. / Incl.",
        "value": "Min. / incl."
      },
      "pricePerUnit": {
        "default": "Price / Unit",
        "value": "Prix / Unité"
      },
      "extras": {
        "default": "Extras",
        "value": "Extras"
      },
      "priceShiftName": {
        "default": "Charge / Discount",
        "value": "Débit / Remise"
      },
      "percent": {
        "default": "Percent",
        "value": "Pourcentage"
      },
      "fix": {
        "default": "Fix",
        "value": "Fixe"
      },
      "bookingTotalPrice": {
        "default": "Grand total",
        "value": "Montant total"
      },
      "billingAmount": {
        "default": "Invoice amount",
        "value": "Montant de la facture"
      },
      "receivedPayments": {
        "default": "Received payments",
        "value": "Paiements reçus"
      }
    },
    "userBookings": {
      "archivedBookings": {
        "default": "Archived bookings",
        "value": "Réservations antérieures"
      },
      "activeBookings": {
        "default": "Active bookings",
        "value": "Réservations actives"
      },
      "myBookings": {
        "default": "My bookings",
        "value": "Mes réservations"
      },
      "noBookingsYet": {
        "default": "No bookings yet.",
        "value": "Pas encore de réservations"
      },
      "number": {
        "default": "Number",
        "value": "Numéro"
      },
      "object": {
        "default": "Rental object",
        "value": "Objet"
      },
      "start": {
        "default": "Start",
        "value": "Début"
      },
      "end": {
        "default": "End",
        "value": "Fin"
      },
      "price": {
        "default": "Price",
        "value": "Prix"
      },
      "state": {
        "default": "Status",
        "value": "Statut"
      },
      "loadMore": {
        "default": "Load more",
        "value": "Télécharger plus"
      }
    },
    "search": {
      "location": {
        "default": "Location",
        "value": "Lieu"
      },
      "allLocations": {
        "default": "All locations",
        "value": "Tous"
      },
      "chooseAllLocations": {
        "default": "All locations",
        "value": "Tous"
      },
      "noItemsLoadedYet": {
        "default": "No items loaded yet.",
        "value": "Aucune entrée n'a encore été chargée"
      },
      "objectType": {
        "default": "Object type",
        "value": "Catégorie"
      },
      "allCategories": {
        "default": "All categories",
        "value": "Tous"
      },
      "chooseAllCategories": {
        "default": "All categories",
        "value": "Tous"
      },
      "startDate": {
        "default": "Start date",
        "value": "Date de début"
      },
      "noStartDateSelected": {
        "default": "No start date selected",
        "value": "Aucune date de début sélectionnée"
      },
      "diration": {
        "default": "Duration",
        "value": "Durée"
      },
      "to": {
        "default": "to",
        "value": "à"
      },
      "count": {
        "default": "Qty.",
        "value": "Quantité"
      },
      "enterUnitsCount": {
        "default": "Enter units count",
        "value": "Entrez la quantité"
      },
      "timeUnit": {
        "default": "Time unit",
        "value": "Unité de temps"
      },
      "enterUnitsType": {
        "default": "Enter units type",
        "value": "Préciser l'unité"
      },
      "properties": {
        "default": "Features",
        "value": "Caractéristiques"
      },
      "doNotCare": {
        "default": "Don't care",
        "value": "Aucun sélectionné"
      },
      "thereAreNoResults": {
        "default": "There were no results for your search.",
        "value": "Votre recherche n'a donné aucun résultat"
      },
      "fromPrice": {
        "default": "Starting at",
        "value": "A partir de"
      },
      "loadMore": {
        "default": "Load more",
        "value": "Télécharger plus"
      },
      "resetParameters": {
        "default": "Reset All",
        "value": "Réinitialiser tout"
      },
      "showAll": {
        "default": "Show All",
        "value": "Tout afficher"
      }         
    },
    "userProfile": {
      "street": {
        "default": "Street, Nr. *",
        "value": "Rue, No. *"
      },      
      "addressAddition": {
        "default": "Address suffix",
        "value": "Suffixe d'adresse"
      },
      "postNumber": {
        "default": "ZIP *",
        "value": "NPA *"
      },
      "place": {
        "default": "Place *",
        "value": "Ville *"
      },
      "country": {
        "default": "Country *",
        "value": "Pays *"
      },
      "registrationTitle": {
        "default": "Sign up",
        "value": "S'enregistrer"
      },
      "profileTitle": {
        "default": "Bonjour",
        "value": "Bonjour ${firstName}"
      },       
      "registrationSubtitle": {
        "default": "Sign up for wy.by.",
        "value": "S'enregistrer pour wy.by"
      },
      "profileSubtitle": {
        "default": "Edit your user profile.",
        "value": "Modifier les données de l'utilisateur"
      },
      "customerInformation": {
        "default": "Customer information",
        "value": "Informations sur les clients"
      },      
      "salutation": {
        "default": "Salutation *",
        "value": "Civilité *"
      },
      "firstName": {
        "default": "First name *",
        "value": "Prénom *"
      },
      "lastName": {
        "default": "Family name *",
        "value": "Nom de famille *"
      },
      "organization": {
        "default": "Organization",
        "value": "Organisation"
      },         
      "email": {
        "default": "Email *",
        "value": "Courriel *"
      },
      "phone": {
        "default": "Phone",
        "value": "Téléphone"
      },
      "mobilePhone": {
        "default": "Cellphone",
        "value": "Mobile *"
      },
      "timeZone": {
        "default": "Timezone",
        "value": "Fuseau horaire"
      },
      "language": {
        "default": "Corresponce language",
        "value": "Langue de correspondance"
      },
      "postalAddress": {
        "default": "Postal Address",
        "value": "Adresse postale"
      },
      "billingAddress": {
        "default": "Billing Address",
        "value": "Adresse de facturation"
      },  
      "useDifferentBillingAddress": {
        "default": "Different billing address",
        "value": "Adresse de facturation différente"
      },
      "password": {
        "default": "Password",
        "value": "Mot de passe"
      },
      "userNameReadOnly": {
        "default": "Username",
        "value": "Nom d'utilisateur"
      },
      "userNameEditable": {
        "default": "Username *",
        "value": "Nom utilisateur"
      },
      "oldPassword": {
        "default": "Old password",
        "value": "Ancien mot de passe"
      },
      "newPassword1": {
        "default": "New password *",
        "value": "Nouveau mot de passe *"
      },
      "newPassword2": {
        "default": "Confirm password *",
        "value": "Confirmez le mot de passe *"
      },
      "acceptAgb": {
        "default": "I accept the ",
        "value": "J'accepte les "
      },
      "agb": {
        "default": "General terms & conditions",
        "value": "Cond. gén."
      },
      "back": {
        "default": "Cancel",
        "value": "Annuler"
      },
      "registrationSave": {
        "default": "Save",
        "value": "Sauvegarder"
      },
      "profileSave": {
        "default": "Save",
        "value": "Sauvegarder"
      },
      "registrationStep2Title": {
        "default": "Registration",
        "value": "Inscription"
      },
      "registrationStep2Subtitle": {
        "default": "Thank you very much for your registration.",
        "value": "Merci beaucoup pour votre inscription."
      },
      "registrationStep2Text": {
        "default": "Please follow a link in your email to activate the account.",
        "value": "Veuillez cliquer sur le lien dans votre courriel pour activer votre compte."
      },
      "registrationStep2GoHome": {
        "default": "Go to homepage",
        "value": "Vers la page d'accueil"
      },
      "registrationStep4Title": {
        "default": "Registration",
        "value": "Inscription"
      },
      "registrationStep4Subtitle": {
        "default": "You have registered successfully.",
        "value": "Vous vous êtes inscrit avec succès."
      },
      "registrationStep4GoHome": {
        "default": "Go to homepage",
        "value": "Vers la page d'accueil"
      }
    },
    "authentication": {
      "loggedOutDueToInactivity": {
        "default": "You were logged out because of inactivity.",
        "value": "Vous avez été déconnecté pour cause d'inactivité.",
      }
    },
    "forgottenPassword": {
      "resetPassword": {
        "default": "Reset password",
        "value": "Réinitialiser le mot de passe",
      },
      "enterEmailAddress": {
        "default": "Please enter the e-mail addresses you used for registration.",
        "value": "Veuillez saisir les adresses électroniques que vous avez utilisées pour l'enregistrement.",
      }, 
      "yourEmailAddress": {
        "default": "Your e-mail address",
        "value": "Votre adresse de courriel",
      }, 
      "cancel": {
        "default": "Cancel",
        "value": "Annuler",
      },   
      "sendEmail": {
        "default": "Send e-mail",
        "value": "Envoyer le courriel",
      }, 
      "forgotPasswordEmail": {
        "default": "Forgotten password e-mail",
        "value": "Mot de passe oublié courriel",
      }, 
      "weHaveSentEmail": {
        "default": "We have sent an email with a password recovery link to ${email}. Please open the email and click on the password recovery link.",
        "value": "Nous avons envoyé un courriel avec un lien de récupération de mot de passe à ${email}. Veuillez ouvrir l'e-mail et cliquer sur le lien de récupération du mot de passe.",
      },  
      "Home": {
        "default": "Homepage",
        "value": "Page d'accueil",
      },
      "enterNewPassword": {
        "default": "Enter your new password and confirm it.",
        "value": "Entrez votre nouveau mot de passe et confirmez-le.",
      },   
      "username": {
        "default": "Username",
        "value": "Nom d'utilisateur",
      }, 
      "newPassword": {
        "default": "New password",
        "value": "Nouveau mot de passe",
      },  
      "repeatNewPassword": {
        "default": "Repeat new password",
        "value": "Répéter le nouveau mot de passe",
      },  
      "passwordComplexityDesc": {
        "default": "The password must be minimum 7 characters with at least one lowercase character and one special character.",
        "value": "Le mot de passe doit comporter au moins 7 caractères, dont au moins une minuscule et un caractère spécial.",
      },
      "save": {
        "default": "Save",
        "value": "Save",
      }, 
      "resetSuccessTitle": {
        "default": "Password successfully reset",
        "value": "Mot de passe réinitialisé avec succès",
      },   
      "resetSuccessDesc": {
        "default": "Your password was successfully reset. Please go to the start page and log in.",
        "value": "Votre mot de passe a été réinitialisé avec succès. Veuillez vous rendre sur la page d'accueil et vous identifier.",
      },                                                                           
    }    
  },
  "unbound": {}
}


// WEBPACK FOOTER //
// ./src/translate/resources/frCH.js